/** Creates an array of elements split into groups the length of size. If array can't be split evenly, the final chunk will be the remaining elements. */
export function chunk<T>(array: Array<T>, size: number): Array<Array<T>> {
  return array.length ? [array.slice(0, size), ...chunk(array.slice(size), size)] : [];
}
